import JwtDecodeService from "./JwtDecodeService";

const GetUserAuthorityService = (accessToken,customerIotProfile) =>{
    const authority = JwtDecodeService(accessToken)?.["user-authorities"][0];
    if(authority === 'CUSTOMER') return customerIotProfile?.role === 'ADMIN'? 'CUSTOMER_ADMIN':'CUSTOMER_USER';
    return authority;
};
export default GetUserAuthorityService;